/** APP CREATE USER */
export const setUser = async() => Date.now().toString(36) + Math.random().toString(36).substr(2, 5);

/** APP SESSION COOKIE  cookie name  = user_pancan_wall_session */
export const setCookie = (name: string, token: string, time: number) => {
    const date = new Date();
    date.setTime(date.getTime() + (time * 365 * 24 * 60 * 60 * 1000)); // in Years
    const expires = `expires=${date.toUTCString()}`;
    const data = {id: token, cookieName: name, session: true, expiresAt: date.toUTCString(), createdAt: new Date()};
    document.cookie = `${name}=${JSON.stringify(data)};${expires};path=/`;
    return data;
}

export const getUserSession = (name: string) => {
    name += '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookie = decodedCookie.split(';');
    for (let i = 0; i < cookie.length; i++) {
         let c = cookie[i];
         while (c.charAt(0) === ' ') {
              c = c.substring(1);
         }
         if (c.indexOf(name) === 0) return JSON.parse(c.substring(name.length, c.length)); //return the value of the cookie if exists
    }
    return false;
}

export const deleteCookie = (name: string, type?:string) => {
    sessionStorage.clear();     
    return document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
}

export const setUserInfoCookie = (type:string, user?:any) => {
    const name = 'user_submitted_info';
    const date = new Date();
    const time = type === 'submission'? 365: 1; // if it is a submission data collected dont ask until next year, otherwise try in 1 day 
    date.setTime(date.getTime() + (time * 24 * 60 * 60 * 1000)); // in Days
    const expires = `expires=${date.toUTCString()}`;

    const data = {
        userInfoSubmission: type === 'submission', 
        userInfoDismissed: type === 'dismissed', 
        expiresAt: date.toUTCString(), 
        createdAt: new Date(),
        firstName: user ? user.firstName: null,
        lastName: user ? user.lastName: null,
        email: user ? user.email: null,
        zip: user ? user.zip: null,
        address: user? user.address: null,
        address2: user? user.address2: null,
        city: user? user.city: null,
        state: user? user.state: null
    };
    document.cookie = `${name}=${JSON.stringify(data)};${expires};path=/`;
    return data;
}